export default __webpack_public_path__ + "media/images/tabs-22c84c9f4e378cd90f66c6bbd9b46e14.png";